import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
import React from "react";
export default function PrivacyPolicy() {

  return (
    <>
      <section className="faq-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="faqlink-area">
                <ul>
                  <li>
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li>|</li>
                  <li> Privacy Policy</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="terms-area">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-5 col-lg-3">
              <div className="faq-quickbox">
                <span className="faqquickbox-text heading">Quick Links</span>
                <ul>
                  <li>
                    <NavLink to="/terms-condition" className={({ isActive }) => isActive ? "active" : ""}>Term & Conditions</NavLink>
                  </li>
                  <li>
                    <NavLink to="/privacy-policy" className={({ isActive }) => isActive ? "active" : ""}>Privacy Policy</NavLink>
                  </li>
                  <li><NavLink to="/faq" className={({ isActive }) => isActive ? "active" : ""}> FAQs</NavLink>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-sm-12 col-md-7 col-lg-9">
              <div className="termscondition-text">
                <h1 className="heading">Privacy policy</h1>
                <p>At Supershine, we are committed to protecting your privacy and ensuring the security of your information. This Privacy Policy explains how we collect, use, store, and protect data when you interact with our website, commercial laundry systems, and services.</p>

                <h2>Information We Collect</h2>
                <span>1. Personal Information</span>
                <ul>

                  <li>Name, company name, email address, phone number, and other contact details submitted through inquiry forms, installation requests, or communications with Supershine.</li>
                </ul>
                <span>2. Non-Personal Information </span>
                <ul>
                  <li>Technical data such as IP address, browser type, operating system, device information, and pages visited on our website, collected through cookies and similar technologies.</li>
                </ul>
                <span>3.  Business & Operational Information </span>
                <ul>
                  <li>Details related to facility requirements, installation specifications, equipment configurations, operational metrics, and commercial discussions shared during business interactions or system implementations.</li>
                </ul>

                <h3>How We Use Your Information </h3>
                <ul>
                  <li>Respond to inquiries and provide commercial laundry solutions</li>
                  <li>Process installation requests, quotations, and service communications</li>
                  <li>Improve our website, systems, and customer experience</li>
                  <li>Share updates, equipment information, or operational communications (only if opted in)</li>
                  <li>Comply with applicable legal, regulatory, or contractual obligations</li>
                </ul>

                <h4>Sharing Your Information</h4>
                <p>Supershine does not sell, rent, or trade your information. We may share data only:</p>
                <ul>
                  <li>With authorized service providers, installation partners, or equipment suppliers assisting in operations or system deployment</li>
                  <li>When required by law or regulatory authorities</li>
                  <li>To protect Supershine's rights, property, operations, or client safety</li>
                </ul>

                <h4>Cookies & Tracking Technologies</h4>
                <p>Our website uses cookies to enhance functionality and understand user behavior. Cookies help improve performance and user experience. You may manage or disable cookies through your browser settings; however, certain website features may be limited.</p>


                <h4>Data Security</h4>
                <p>We limit access to information strictly to authorized employees, contractors, installation teams, and service partners who require it to perform their responsibilities. All such parties are obligated to maintain confidentiality and adhere to applicable data protection standards and contractual safeguards.</p>
                <p>Despite our best efforts, users should be aware that no system is entirely immune to security risks. By using our website and services, you acknowledge and accept this inherent risk. Supershine will not be held responsible for unauthorized access caused by factors beyond our reasonable control, including cyberattacks or third-party breaches.</p>

                <h4>Your Rights</h4>
                <p>To exercise these rights, please contact Supershine through the details provided on our website. We will review and respond to all legitimate requests in a timely manner, subject to applicable legal and regulatory obligations.</p>
                <ul>
                  <li>Access, correct, or update your information.</li>
                  <li>Request deletion of your data, subject to legal requirements.</li>
                  <li>Opt out of marketing communications.</li>
                  <li>Request details about how your information is processed.</li>
                </ul>
                <p>Supershine may require verification of identity before processing any data-related requests to ensure the protection of your information.</p>

                <h4>Changes to This Privacy Policy</h4>
                <p>Supershine may update this Privacy Policy periodically to reflect changes in our business practices, legal requirements, or technological advancements. Any updates or modifications will be clearly posted on this page along with the revised effective date, ensuring transparency for all users.</p>
                <p>We encourage users to review this Privacy Policy regularly to stay informed about how we collect, use, and protect information. Your continued access to or use of the Supershine website, commercial laundry systems, or services after any changes constitutes your acknowledgment and acceptance of the updated Privacy Policy.</p>
                <p>If you have any questions, concerns, or require clarification regarding this Privacy Policy or our data practices, you may contact Supershine through the contact details provided on our website. We remain committed to safeguarding your information and maintaining your trust at all times.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}